<div [@routerTransition]>
    <div class="kt-subheader kt-grid__item">
        <div class="kt-subheader__main">
            <h3 class="kt-subheader__title">
                <span>{{ "Axilla.Webshop.FieldAgent.NewOrder" | localize }}</span>
            </h3>
            <span class="kt-subheader__separator kt-subheader__separator--v"></span>
            <span class="kt-subheader__desc">
                {{ "Axilla.Webshop.FieldAgent.NewOrderHeaderInfo" | localize }}
            </span>
        </div>
        <div class="kt-subheader__toolbar" *ngIf="isShowContinue">
            <div class="kt-subheader__wrapper">
                <button (click)="continue()"
                        class="btn btn-primary">
                    <i class="fa fa-plus"></i>
                    {{"Continue" | localize}}</button>
            </div>
        </div>
    </div>

    <div class="kt-content">
        <div class="kt-portlet kt-portlet--mobile">
            <div class="kt-portlet__body p-4">
                <div>
                    <h5 class="mb-3">
                        {{ "Axilla.Webshop.FieldAgent.SelectBrand" | localize }}
                    </h5>

                    <div class="brands-container">
                        <ng-container *ngFor="let brand of brandsValue">
                            <p-chip (click)="onBrandSelect(brand)" label="{{brand.name}}" [ngClass]="{'selected-brand': brand.id === selectedBrand?.id}"></p-chip>
                        </ng-container>
                    </div>
                </div>
            </div>

            <div class="kt-portlet__body p-4">
                <div>
                    <h5 class="mb-3">
                        {{ "Axilla.Webshop.FieldAgent.SelectTemplate" | localize }}
                    </h5>

                    <div class="primeng-datatable-container products">
                        <p-table [value]="primengTableHelper.records"
                                 #dataTable
                                 rows="{{primengTableHelper.defaultRecordsCountPerPage}}"
                                 responsiveLayout="stack"
                                 [breakpoint]="'748px'"

                                 selectionMode="single"
                                 [(selection)]="selectedOrderGuideTemplate"
                                 (onRowSelect)="onTemplateSelect($event)"
                                 (onRowUnselect)="onTemplateUnselect($event)">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th style="width: 12em;">
                                        <span translation="Axilla.OrderGuide.Template.StartDate"
                                              source="Axilla"></span>
                                    </th>

                                    <th style="width: 12em">
                                        <span translation="Axilla.OrderGuide.Template.EndDate"
                                              source="Axilla"></span>
                                    </th>
                                    <th>
                                        <span translation="Axilla.OrderGuide.Template.Name"
                                              source="Axilla"></span>
                                    </th>
                                    <th>
                                        <span translation="Axilla.OrderGuide.Template.Description"
                                              source="Axilla"></span>
                                    </th>
                                </tr>
                            </ng-template>

                            <ng-template pTemplate="body" let-record="$implicit">
                                <tr [pSelectableRow]="record">
                                    <td>
                                            <span class="p-column-title">
                                                 <span translation="Axilla.OrderGuide.Template.StartDate"
                                                       source="Axilla"></span>
                                            </span>
                                        {{ record.startTime | date:'yyyy-MM-dd HH:mm:ss' }}
                                    </td>

                                    <td>
                                            <span class="p-column-title">
                                                 <span translation="Axilla.OrderGuide.Template.EndDate"
                                                       source="Axilla"></span>
                                            </span>
                                        {{ record.endTime | date:'yyyy-MM-dd HH:mm:ss' }}
                                    </td>
                                    <td>
                                            <span class="p-column-title">
                                                <span translation="Axilla.OrderGuide.Template.Name"
                                                      source="Axilla"></span>
                                            </span>
                                        {{ record.name }}
                                    </td>
                                    <td style="">
                                            <span class="p-column-title">
                                                <span translation="Axilla.OrderGuide.Template.Description"
                                                      source="Axilla"></span>
                                            </span>
                                        {{ record.description }}
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                        <div class="primeng-no-data"
                             *ngIf="primengTableHelper.totalRecordsCount == 0 && !primengTableHelper.isLoading">
                            <span translation="Axilla.NoData" source="Axilla"></span>
                        </div>
                        <div class="primeng-no-data" *ngIf="primengTableHelper.isLoading">
                            <span translation="Axilla.LoadingData" source="Axilla"></span>
                        </div>

                        <div class="spinner-container" *ngIf="primengTableHelper.isLoading">
                            <p-progressSpinner></p-progressSpinner>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>
